import React, { useEffect, useState, useContext } from 'react';
import axiosConn from '../../axiosConn';
import { Spinner } from 'react-bootstrap';
import { AuthContext } from '../../context/AuthContext';

const PlayerLeaderboard = ({
  businessId,
  //   startDate={startDate}
  //   endDate={endDate}
  category = 'checkin',
  region = 'global',
  limit = 10,
}) => {
  const { player } = useContext(AuthContext);
  const [players, setPlayers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      try {
        const { data } = await axiosConn.get(`checkins/leaderboard/`, {
          params: { businessId, region, limit },
          headers: { Authorization: `Bearer ${player?.token}` },
        });
        // console.log('Leaderboard data:', data);
        setPlayers(data.data);
      } catch (error) {
        console.error('Error fetching leaderboard:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchLeaderboard();
  }, [category, region, limit, player?.token]);

  if (loading) return <Spinner text="Loading leaderboard..." />;

  // Simple avatar fallback
  const getAvatar = (profilePhoto, playerId) =>
    profilePhoto ? (
      <img
        src={profilePhoto}
        alt={playerId}
        style={{
          width: 38,
          height: 38,
          borderRadius: '50%',
          objectFit: 'cover',
          border: '2px solid #e0e7ef',
          background: '#f1f5f9',
        }}
      />
    ) : (
      <div
        style={{
          width: 38,
          height: 38,
          borderRadius: '50%',
          background: '#e0e7ef',
          color: '#64748b',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          fontWeight: 700,
          fontSize: 18,
          border: '2px solid #e0e7ef',
        }}
      >
        {playerId?.slice(0, 2)?.toUpperCase() || '??'}
      </div>
    );

  return (
    <div className="mt-4">
      <h3 className="text-xl font-semibold mb-3">
        🏆 Top Players ({category})
      </h3>
      <div className="space-y-2">
        {players.map((player, index) => (
          <div
            key={player._id}
            className="d-flex align-items-center p-3 mb-2 rounded shadow-sm"
            style={{ background: '#fff', minHeight: 56 }}
          >
            <div
              style={{
                fontWeight: 700,
                width: 28,
                textAlign: 'right',
                marginRight: 12,
              }}
            >
              {index + 1}
            </div>
            {getAvatar(player.profilePhoto, player.playerId)}
            <div style={{ marginLeft: 14 }}>
              <div style={{ fontWeight: 500 }}>{player.playerId}</div>
              <div style={{ fontSize: 13, color: '#64748b' }}>
                {player.xp} XP
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default PlayerLeaderboard;
